import "jquery-ui/themes/base/core.css";
import "jquery-ui/themes/base/menu.css";
import "jquery-ui/themes/base/autocomplete.css";
import "jquery-ui/themes/base/theme.css";
import autocomplete from "jquery-ui/ui/widgets/autocomplete";
import "libs/jquery-ui.autocomplete.extensions";
import "@/pages/base/styles/base/UIStandard.scss";
import "./vendor.jqueryui.scss";

export interface JQueryUIAutocompleteOptionType {
    label: string;
    value: string | number;
}

type JQueryUIAutocompleteEventHandler = (event: JQueryEventObject, ui: any) => void;

interface JQueryUIAutocompleteOptions {
    minLength?: number;
    html?: true;
    appendTo?: string;
    delay?: number;
    disabled?: boolean;
    classes?: { [k: string]: string };
    position?: {
        my: string;
        at: string;
        collision: "none";
    };
    autoFocus?: boolean;
    source:
    | string
    | string[]
    | JQueryUIAutocompleteOptionType[]
    | ((req: { term: string }, res: (data?: JQueryUIAutocompleteOptionType[]) => void) => void);
    _renderMenu?: (ul: JQuery, items: JQueryUIAutocompleteOptionType[]) => void;
    _renderItem?: (ul: JQuery, item: JQueryUIAutocompleteOptionType) => JQuery;
    search?: JQueryUIAutocompleteEventHandler;
    select?: JQueryUIAutocompleteEventHandler;
    change?: JQueryUIAutocompleteEventHandler;
    close?: JQueryUIAutocompleteEventHandler;
    create?: JQueryUIAutocompleteEventHandler;
    focus?: JQueryUIAutocompleteEventHandler;
    open?: JQueryUIAutocompleteEventHandler;
    response?: JQueryUIAutocompleteEventHandler;
}

declare class JQueryAutoCompleteType {
    public readonly element: JQuery;
    constructor(opts: JQueryUIAutocompleteOptions);
    close(): void;
    focus(): void;
    search(q: string): void;
}

const JQueryAutoComplete = autocomplete as typeof JQueryAutoCompleteType;

export { JQueryAutoComplete };
